import { Activity } from "lucide-react";
import { useLang } from "@/i18n";

export default function Status() {
  const { lang } = useLang();
  const t = (tr, en) => (lang === "tr" ? tr : en);
  return (
    <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-16" data-testid="status-page">
      <div className="flex items-center gap-3 mb-6">
        <Activity className="text-red-500" size={28} />
        <span className="eyebrow text-red-500">DURUM · Loft Press API</span>
      </div>
      <h1 className="headline text-5xl sm:text-6xl text-white">
        {t("Servis Durumu", "Service Status")}
      </h1>
      <p className="mt-6 text-lg text-neutral-300 leading-relaxed max-w-2xl">
        {t(
          "API servis durumunu kontrol etmek için bu sayfayı kullanabilirsiniz. Ayrıntılı ölçüm sayfası hazırlanıyor.",
          "You may use this page to check API service status. A detailed metrics page is being prepared."
        )}
      </p>

      <div className="mt-10 bg-neutral-950 border border-neutral-800 rounded-sm p-6">
        <p className="eyebrow text-neutral-500">{t("MEVCUT DURUM", "CURRENT STATUS")}</p>
        <p className="mt-2 text-neutral-300">
          {t("Servis durum bilgileri hazırlanıyor.", "Service status information is being prepared.")}
        </p>
      </div>
    </div>
  );
}
